import axios from "axios";

import { IP } from "../utils/Host";


export function updateWydzielWykonanieZgrupyGant(global_id_wykonania,fechparametryTechnologii,zamowienie_id,refreshGantAll) {

// id = procesor id

  axios.get(IP + "updateWydzielWykonanieZgrupy/"+global_id_wykonania)
    .then((res) => {
    // console.log("technologia_id " +res.data[0].technologia_id)
    // fechparametryTechnologii

    
    fechparametryTechnologii(zamowienie_id,res.data[0].technologia_id)

    }).then((res) => {

    refreshGantAll()

    });
}
